import {
  ArrowRightIcon,
  Backdrop,
  ClockCircleIcon,
  LoadingSpinnerIconTwoTone,
  SelfTapesIcon,
  Typography,
  useNotificationModal,
} from '@room-match/shared-ui-components';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { AuditionPhase } from 'shared/enums/AuditionPhase';
import { AuditionStatus } from 'shared/enums/AuditionStatus';

import { COLORS } from 'shared/constants/COLORS';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import { auditionService } from 'shared/services/auditionService';
import { ls } from 'shared/utils/ls';
import { timeParser } from 'shared/utils/timeHelpers';
import { CardContainer, CardHeader, EmptyContainer } from '../Dashboard.styles';
import { CustomIconButton, ItemContainer, Left, ListContainer, Middle } from './SubmittedSelfTapes.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';

type Props = {
  count: number;
};

const { getAuditionSchedules } = auditionScheduleService();
const { getAudition } = auditionService();
const SubmittedSelfTapes: React.FC<Props> = ({ count = 0 }) => {
  const history = useHistory();
  const { handleOpen, isOpen, NotificationModal, handleSetMessage, handleChangeModalType } = useNotificationModal({
    type: 'warning',
  });
  const [audID, setaudID] = useState('');
  const { data: audData, isLoading: audLoading } = getAudition(audID);
  const { data, isLoading } = getAuditionSchedules({
    phase: AuditionPhase.SELF_TAPES,
    status: AuditionStatus.CONFIRMED,
    first: 2,
    after: '',
  });

  const getData = useMemo(() => {
    return data
      ? data.pages.filter((v, index) => index === 0).map((i) => i.data.talent_audition_schedules_connection.nodes)
      : undefined;
  }, [data]);

  console.log('getData: ', getData);

  const { setLS } = ls();

  useEffect(() => {
    if (!audLoading && audData?.data && audID !== '') {
      if (!audData.data.attributes.audition.data.attributes.casting_role.data.attributes.self_tapes_requirements) {
        handleChangeModalType('error');
        handleSetMessage(
          'Currently Unavailable',
          `You are unable to submit a self tape at this time as no requirements have been set yet by the casting director, please check with your agency or the casting contact directly.`,
          'OK',
        );
        handleOpen();
        return;
      }
      setLS('auditionData', JSON.stringify(audData?.data));
      const tape = (getData || [])[0].find((f) => f.id === audID);
      history.push(`${ROUTES.TALENT.SELFTAPES}/${tape?.audition.casting_role.project.id}/${tape?.id}/size_card`);
    }
  }, [audData, audLoading, audID]);

  const due = (i: IAuditionSchedulesAttributes) =>
    // selftapesDueComputer(
    //   i.audition.casting_role.self_tapes_requirements?.date || '',
    //   i.audition.casting_role.self_tapes_requirements?.timezone || '',
    // );

    timeParser(
      i.audition.casting_role.self_tapes_requirements?.date || '',
      i.audition.casting_role.self_tapes_requirements?.time || '',
      i.audition.casting_role.self_tapes_requirements?.timezone || '',
    );

  if (isLoading || audLoading) return <Backdrop isLoading={true} />;
  return (
    <CardContainer>
      <CardHeader>
        <div>
          <SelfTapesIcon />
          <span style={{ fontSize: 18 }}>Submit Self Tapes</span>
        </div>
        <Link to={ROUTES.TALENT.SELFTAPES}>
          <CustomTypography fontSize={14} color="primary">
            {count === 0 ? `` : count > 1 ? `${count} Self Tapes` : `${count} Self Tape`}
          </CustomTypography>
        </Link>
      </CardHeader>
      <ListContainer>
        {isLoading ? (
          <LoadingSpinnerIconTwoTone />
        ) : getData && getData[0].length > 0 ? (
          getData[0].map(
            (i, n) =>
              i && (
                <ItemContainer key={n} onClick={() => setaudID(i.id)}>
                  <Left>
                    {/* <CheckMarkIconTwoTone />
                    <Typography>Submitted</Typography>
                    <Typography fontSize={12} color="darkGrey">
                      {i.checked_in_at ? getFormalDateShort(new Date(i.checked_in_at)) : '–'}
                    </Typography> */}
                    <ClockCircleIcon htmlColor={due(i).includes('D') ? COLORS.PRIMARY : COLORS.DANGER} />
                    <CustomTypography fontSize={16} fontWeight={500}>
                      {due(i)}
                    </CustomTypography>
                    <CustomTypography fontSize={12}>Due Time</CustomTypography>
                  </Left>
                  <Middle>
                    <div>
                      <CustomTypography fontWeight={500}>
                        {i.audition.casting_role.project.name || '–'}
                      </CustomTypography>
                      <CustomTypography fontSize={10}>{i.audition.casting_role.name || ''}</CustomTypography>
                    </div>
                    <div>
                      {i.audition.profile.agency && (
                        <CustomTypography fontSize={14}>
                          {i.audition.profile.agency.state && i.audition.profile.agency.country
                            ? `${i.audition.profile.agency.state}, ${i.audition.profile.agency.country}`
                            : i.audition.profile.agency.state
                              ? i.audition.profile.agency.state
                              : i.audition.profile.agency.country
                                ? i.audition.profile.agency.country
                                : ''}
                        </CustomTypography>
                      )}
                      {i.audition.profile.agency &&
                      (i.audition.profile.agency.full_name || i.audition.profile.agency.name) ? (
                        <CustomTypography color="primary" fontSize={14}>
                          {i.audition.profile.agency.full_name || i.audition.profile.agency.name}
                        </CustomTypography>
                      ) : (
                        <CustomTypography color="primary" fontSize={14}>
                          Non Represented
                        </CustomTypography>
                      )}
                    </div>
                  </Middle>
                  <CustomIconButton>
                    <ArrowRightIcon />
                  </CustomIconButton>
                </ItemContainer>
              ),
          )
        ) : (
          <EmptyContainer>No data available</EmptyContainer>
        )}
      </ListContainer>
      {isOpen && <NotificationModal onClose={() => setaudID('')} />}
    </CardContainer>
  );
};

export default SubmittedSelfTapes;
